<template>
  <Transition name="upgrade-overlay">
    <div v-if="required" class="upgrade-overlay" role="alertdialog" aria-modal="true" aria-labelledby="upgrade-overlay-title">
      <div class="upgrade-overlay__card">
        <h1 id="upgrade-overlay-title" class="upgrade-overlay__title">Update required</h1>
        <p class="upgrade-overlay__body">
          The server has moved to a new data format. Please refresh to get the
          latest version of the app before you can continue syncing.
        </p>
        <button class="upgrade-overlay__btn" @click="reload">Refresh now</button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref } from 'vue';

// Schema upgrade notifications are now surfaced via RxDB's per-collection
// schemaVersion mismatch (HTTP 426). This overlay is retained for future use
// and can be wired to the RxDB replication error stream when needed.
const required = ref(false);

const reload = (): void => {
  window.location.reload();
};
</script>

<style scoped>
.upgrade-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
  background: rgba(0, 0, 0, 0.55);
}

.upgrade-overlay__card {
  max-width: 420px;
  width: 100%;
  background: var(--color-background-secondary, #fff);
  border-radius: var(--radius-lg, 12px);
  padding: var(--space-lg);
  box-shadow: var(--shadow-lg);
  text-align: center;
}

.upgrade-overlay__title {
  margin: 0 0 var(--space-sm);
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
}

.upgrade-overlay__body {
  margin: 0 0 var(--space-md);
  color: var(--color-text-secondary);
  line-height: 1.5;
}

.upgrade-overlay__btn {
  display: inline-block;
  min-height: 44px;
  padding: 0 var(--space-lg);
  border: none;
  border-radius: var(--radius-md, 8px);
  background: var(--color-primary);
  color: #fff;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}

.upgrade-overlay__btn:active {
  opacity: 0.8;
}

.upgrade-overlay-enter-active,
.upgrade-overlay-leave-active {
  transition: opacity 200ms ease;
}

.upgrade-overlay-enter-from,
.upgrade-overlay-leave-to {
  opacity: 0;
}
</style>
